import firebase from "firebase/app"
import "firebase/auth"

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
    firebaseConfig.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
}

if (!firebaseConfig.apiKey) {
    console.error(
        "Firebase config missing! REACT_APP_FIREBASE_* env vars were not set at build time. " +
        "Check that client/.env.development or client/.env.production exists."
    );
}

const app = firebase.initializeApp(firebaseConfig);

export const auth = app.auth()
export default app
